<template>
  <page-layout
    :breadcrumbs="[
      {
        text: this.$t('navDrawer.home').toUpperCase(),
        disabled: false,
        to: {name: 'home'},
        exact: true
      },
      {
        text: localization.title.toUpperCase(),
        disabled: true,
        exact: false
      }
    ]"
  >
    <v-container fluid>
      <o-main-progress
        v-if="loading"
      />
      <v-row 
        v-else
        wrap no-gutters
      >
        <v-col cols="12" class="mb-4">
          <section-layout
            :disabled="true"
            :showButton="false"
          >
            <template v-slot:title>
              {{localization.datosAcceso.title}}
            </template>
            <template v-slot:content>
              <v-row justify="center">
                <v-col cols="12" sm="10" md="8">
                  <v-text-field
                    disabled
                    :label="localization.datosAcceso.inputs.email"
                    :value="usuario.email"
                  />
                </v-col>
              </v-row>
            </template>
          </section-layout>
        </v-col>
        <v-col cols="12" class="mb-4">
          <section-layout
            :disabled="!cambiadoAlert || saving"
            :loading="saving"
            @save="guardarCambios()"
          >
            <template v-slot:title>
              {{localization.datosPersonales.title}}
            </template>
            <template v-slot:content>
              <v-form v-model="valid" id="valid" ref="form">
                <v-row justify="center">
                  <v-col cols="12" sm="10" md="8">
                    <v-text-field
                      :label="localization.datosPersonales.inputs.nombre"
                      v-model="usuario.nombre" id="usuario.nombre"
                    />
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" sm="10" md="8">
                    <v-text-field
                      :label="localization.datosPersonales.inputs.apellidos"
                      v-model="usuario.apellidos" id="usuario.apellidos"
                    />
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="6" sm="5" md="4">
                    <v-text-field
                      :label="localization.datosPersonales.inputs.telefono"
                      v-model="usuario.telefono" id="usuario.telefono"
                      class="pr-1"
                      :rules="[rules.integerNumber0]"
                    />
                  </v-col>
                  <v-col cols="6" sm="5" md="4">
                    <v-select
                      :label="localization.datosPersonales.inputs.idioma"
                      class="pl-1"
                      v-model="usuario.idioma" id="usuario.idioma"
                      :items="idiomas"
                      item-text="nombre"
                      item-value="codigo"
                    />
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="6" sm="5" md="4">
                    <v-select
                      :label="localization.datosPersonales.inputs.tipo"
                      v-model="usuario.tipoDocumento" id="usuario.tipoDocumento"
                      :items="tiposDocumento"
                      item-text="nombre"
                      item-value="codigo"
                    />
                  </v-col>
                  <v-col cols="6" sm="5" md="4">
                    <v-text-field
                      :label="localization.datosPersonales.inputs.nDocumento"
                      v-model="usuario.documento" id="usuario.documento"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </template>
          </section-layout>
        </v-col>
      </v-row>
    </v-container>
  </page-layout>    
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import alertBeforeExit from '@/mixins/alertBeforeExit'
import rulesMixin from '@/components/generic/rules.js'

export default {
  mixins: [alertBeforeExit, rulesMixin],
  data () {
    return {
      loading: false,
      saving: false,
      usuario: {},
      valid: true
    }
  },
  async created () {
    this.loading = true
    this.inicializarUsuario()
    this.loading = false
  },
  computed: {
    ...mapGetters({
      usuarioStore: 'login/usuario'
    }),
    localization () {
      return this.$t('sectionPerfil')
    },
    tiposDocumento () {
      return [
        {
          nombre: this.localization.datosPersonales.tiposDocumento.NIF,
          codigo: 'NIF'
        },
        {
          nombre: this.localization.datosPersonales.tiposDocumento.NIE,
          codigo: 'NIE'
        },
        {
          nombre: this.localization.datosPersonales.tiposDocumento.PAS,
          codigo: 'PAS'
        },
        {
          nombre: this.localization.datosPersonales.tiposDocumento.OTR,
          codigo: 'OTR'
        }
      ]
    },
    idiomas () {
      return [
        {
          nombre: this.$t('es'),
          codigo: 'es'
        },
        {
          nombre: this.$t('en'),
          codigo: 'en'
        }
      ]
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      updateActor: 'login/updateActor'
    }),
    async inicializarUsuario () {
      this.usuario = {
        email: this.usuarioStore.email,
        nombre: this.usuarioStore.nombre,
        apellidos: this.usuarioStore.apellidos,
        telefono: this.usuarioStore.telefono,
        documento: this.usuarioStore.documento,
        tipoDocumento: this.usuarioStore.tipoDocumento,
        idioma: this.usuarioStore.idioma
      }
      await this.$nextTick()
      this.cambiadoAlert = false
    },
    async guardarCambios () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t("revisarCamposRojo"), color: 'error'})
      } else {
        const obj = {
          actorName: this.usuario.nombre,
          actorSurname: this.usuario.apellidos,
          actorPhoneNumber: this.usuario.telefono,
          actorLanguage: this.usuario.idioma,
          actorDocumentType: this.usuario.tipoDocumento,
          actorNumDocument: this.usuario.documento
        }
        try {
          this.saving = true
          await this.updateActor(obj)
          this.inicializarUsuario()
          this.addAlert({ texto: this.t('datosGuardadosConExito'), color: 'success' })
        } catch (error) {
          this.addAlert({ texto: this.$t('errorGuardadoDatos'), color: 'error' })
        }
        this.saving = false
      }
    }
  },
  watch: {
    usuario: {
      deep: true,
      handler () {
        this.cambiadoAlert = true
      }
    }
  }
}
</script>